module.exports = "blog"